<template>
    <div>
        <b-modal ref="modal" @hide="hide" id="changeOrder_modal" hide-footer centered size="lg" modal-class="changeOrder">
            <ModalTopContentShare :modalTopContent="orderDetail" />
            <div class="cart_list">
                <form>
                <div class="cart_listcontent">
                    <Student v-for="(student, index) in students" v-bind:key="index" :index="index" :student="student"/>
                    <div class="changeOrder_btn">
                        <div class="row justify-content-center">
                            <div class="col-auto">
                                <button class="hoverFill" type="button" @click="hide">返回離開</button>
                            </div>
                            <div class="col-auto">
                                <button class="hoverShallow" type="button" @click="submit">送出儲存</button>
                            </div>
                        </div>
                    </div>
                </div>
                </form>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import ModalTopContentShare from '@/components/modal/ModalTopContentShare'
    import Student from './partials/Student'
    import { mapGetters, mapActions } from 'vuex'

    export default {
        components: {
            ModalTopContentShare,
            Student,
        },
        computed: {
            ...mapGetters('orderDetail', [
                'showModal',
                'orderDetail',
                'students',
            ]),
        },
        watch: {
            showModal(val) {
                if (val) {
                    this.$refs.modal.show();
                } else {
                    this.$refs.modal.hide();
                }
            },
        },
        methods: {
            ...mapActions('orderDetail', [
                'hide',
                'editOrderDetailStudents'
            ]),
            submit() {
                if (!this.errors.items.length) {
                    this.editOrderDetailStudents();
                }
            },

        },
    }
</script>

